import { Alert } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import StepTemplate from 'FRONTEND/components/Calendar/AppointmentForm/StepTemplate';
import LocationSelector from 'FRONTEND/components/Location/LocationSelector';
import { pickLocation } from 'FRONTEND/reducers/bookingSlice';
import { listLocations, listLocationsWithSlot, selectLocationById, selectLocationsWithSlots } from 'FRONTEND/reducers/locationSlice';
import i18n from 'FRONTEND/utils/i18n';


const LOADING_TRIGGER_ACTION_CREATOR_LIST = [
  listLocationsWithSlot.pending,
  listLocations.pending,
];


const LocationStep = ({ isLocked, isCompleted, onStepClick, onStepCompleted, shouldReset, ...otherProps }) => {
  const dispatch = useDispatch();
  const locationsWithSlot = useSelector(selectLocationsWithSlots);
  const isLocationWithSlotLoading = useSelector((state) => LOADING_TRIGGER_ACTION_CREATOR_LIST.some((actionCreator) => state.app.requestCounter[actionCreator.toString()] > 0));
  const selectedLocation = useSelector((state) => selectLocationById(state, state.booking.selectedLocationId));

  const handleLocationSelect = (locationId) => {
    dispatch(pickLocation({ id: locationId }));
    if (locationId) {
      onStepCompleted();
    }
  };

  useEffect(() => {
    if (shouldReset) {
      dispatch(pickLocation({ id: null }));
    }
  }, [shouldReset]);


  const displayName = selectedLocation?.description ?? '';

  return (
    <StepTemplate
      label={i18n._('Location')}
      isLocked={isLocked}
      onEditClick={() => onStepClick()}
      isStepCompleted={isCompleted}
      editText={displayName}
      {...otherProps}
    >
      {locationsWithSlot.length === 0 && !isLocationWithSlotLoading ? (
        <Alert severity='info'>{i18n._('No location is available for scheduling appointments.')}</Alert>
      ) : (
        <LocationSelector
          locationList={locationsWithSlot}
          onLocationSelect={handleLocationSelect}
          selectedLocationId={selectedLocation?.id}
          disableCreation
        />
      )}
    </StepTemplate>
  );
};

export { LocationStep };
